import { Box, Button, styled } from '@material-ui/core';

export const BackButtonWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ContentCard = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(4),
  borderRadius: 12,
  border: `1px solid ${theme.palette.border}`,
  boxShadow: theme.shadows[1],
}));

export const ClientCredentialsContentCard = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 760,
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(4, 4, 8, 4),
  borderRadius: 12,
  border: `1px solid ${theme.palette.border}`,
  boxShadow: theme.shadows[1],
}));

export const BackButton = styled(Button)({
  paddingLeft: 0,
  textTransform: 'none',
  fontWeight: 700,
});
